import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'

import procesos from './procesos'
import notas from './../notas'
import grupo from './grupo'
import gruposkill from './gruposkill'
import totalsize from './totalsize'
import gruposkillhistory from './gruposkillhistory'
import procesossupervision from './procesossupervision'
import procesossupervisionhistory from './procesossupervisionhistory'

import axios from '@/plugins/axios'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { toLocale } from '@/util/dateutils'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'caso',
    ...crudState(),

    stage: 'todos',
    usuario: 'todos',
    destacados: false,
    prioridad: 'todos',
    seleccion: [],
    expanded: false,
    searchCaso: false,
    casoIntegracion: 0,
    searchCaseAccount: false,
    searchCaseContact: false,
    editHistCase: false,
    searchCaseKeep: '',
    routerSearch: '',
    storeSearch: '',
    paginationSelectedKeep: {},
    pagination: {},
    keepViewCardList: true, // Mantener vista Tablero/Lista al volver de un caso
    paramatrosSeleccionados: [// conservar parametros seleccionados en tarjeta al volver de un caso
      'showAsunto',
      'showContacto',
      'showCuenta',
      'showUsuarioAsignado',
      'showFecha',
      'showTipo',
      'showEstado',
      'showCanal',
      'showSLO'
    ],
    activeFilter: 'casosAbiertos',
    proceso: 'todos',
    idBifurcacion: null
  }),
  getters: {
    ...crudGetters,

    paginationGetTotalSize(state){
      return state.pagination.size;
    },
    filtroPorStageYPrioridad (state) {
      return state.all.filter(item => (state.stage === 'todos' || state.stage === item.idstageactual) && (state.prioridad === 'todos' || state.prioridad === item.idprioridad) && (!state.destacados || item.destacado))
    },
    filtroPorUsuarioYPrioridad (state) {
      return state.all.filter(item => (state.usuario === 'todos' || state.usuario === item.idusuarioasignado) && (state.prioridad === 'todos' || state.prioridad === item.idprioridad) && (!state.destacados || item.destacado))
    },
    filtroPorProcesoYPrioridad (state) {
      return state.all.filter(item => (state.proceso === 'todos' || state.proceso === item.idworkflow) && (state.prioridad === 'todos' || state.prioridad === item.idprioridad) && (!state.destacados || item.destacado))
    },
    numeroCasosDestacados (state) {
      return state.all.reduce((p, c) => (p + (c.destacado ? 1 : 0)), 0)
    },
    numeroCasosPorStage (state) {
      const todos = state.all.length
      return state.all.reduce((p, c) => {
        if (!p.hasOwnProperty(c.idstageactual)) {
          p[c.idstageactual] = 0
        }
        p[c.idstageactual]++

        return p
      }, { todos })
    },
    numeroCasosPorUsuario (state) {
      const todos = state.all.length
      return state.all.reduce((p, c) => {
        if (!p.hasOwnProperty(c.idusuarioasignado)) {
          p[c.idusuarioasignado] = 0
        }
        p[c.idusuarioasignado]++

        return p
      }, { todos })
    },
    numeroCasosPorProceso (state) {
      const todos = state.all.length
      return state.all.reduce((p, c) => {
        if (!p.hasOwnProperty(c.idworkflow)) {
          p[c.idworkflow] = 0
        }
        p[c.idworkflow]++

        return p
      }, { todos })
    },
    numeroCasosPorPrioridad (state) {
      const todos = state.all.length
      return state.all.reduce((p, c) => {
        if (!p.hasOwnProperty(c.idprioridad)) {
          p[c.idprioridad] = 0
        }
        p[c.idprioridad]++

        return p
      }, { todos })
    },
    stage: state => state.stage,
    destacados: state => state.destacados,
    prioridad: state => state.prioridad,
    seleccion: state => state.seleccion,
    usuario: state => state.usuario,
    proceso: state => state.proceso,
    allLoc (state) {
      for (let i = 0; i < state.all.length; i++) {
        state.all[i] = toLocale(state.all[i], 'duedate', 'duedateloc')
      }
      return state.all
    },
    expanded: state => state.expanded,
    casoIntegracion: state => state.casoIntegracion,
    searchCaseAccount: state => state.searchCaseAccount,
    searchCaseContact: state => state.searchCaseContact,
    editHistCase: state => state.editHistCase,
    searchCaseKeep: state => state.searchCaseKeep,
    routerSearch: state => state.routerSearch,
    storeSearch: state => state.storeSearch,
    paginationSelectedKeep: state => state.paginationSelectedKeep,
    keepViewCardList: state => state.keepViewCardList, // Mantener vista Tablero/Lista al volver de un caso
    paramatrosSeleccionados: state => state.paramatrosSeleccionados, // conservar parametros seleccionados en tarjeta al volver de un caso
    activeFilter: state => state.activeFilter, // variable para activar el filtro seleccionado
    idBifurcacion: state => state.idBifurcacion
  },
  mutations: {
    ...crudMutations,

    setStage (state, value) {
      state.stage = state.stage === value ? 'todos' : value
    },
    setUsuario (state, value) {
      state.usuario = state.usuario === value ? 'todos' : value
    },
    setProceso (state, value) {
      state.proceso = state.proceso === value ? 'todos' : value
    },
    setDestacados (state, value) {
      state.destacados = value
    },
    setPrioridad (state, value) {
      state.prioridad = state.prioridad === value ? 'todos' : value
    },
    setSeleccion (state, value) {
      state.seleccion = value
    },
    setExpand (state, value) {
      state.expanded = value
    },
    setSearchCaso (state, value) {
      state.searchCaso = value
    },
    setCasoIntegracion (state, value) {
      state.casoIntegracion = value
    },
    setSearchCaseAccount (state, value) {
      state.searchCaseAccount = value
    },
    setSearchCaseContact (state, value) {
      state.searchCaseContact = value
    },
    setEditHistCase (state, value) {
      state.editHistCase = value
    },
    setSearchCaseKeep (state, value) {
      state.searchCaseKeep = value
    },
    setRouterSearch (state, value) {
      state.routerSearch = value
    },
    setStoreSearch (state, value) {
      state.storeSearch = value
    },
    setPaginationSelectedKeep (state, value) {
      state.paginationSelectedKeep = value
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setkeepViewCardList (state, value) { // Mantener vista Tablero/Lista al volver de un caso
      state.keepViewCardList = value
    },
    setParamatrosSeleccionados (state, value) { // conservar parametros seleccionados en tarjeta al volver de un caso
      state.paramatrosSeleccionados = value
    },
    setActiveFilter (state, value) { // settea el valor del filtro seleccionado
      state.activeFilter = value
    },
    setIdBifurcacion (state, value) {
      state.idBifurcacion = value
    }
  },
  actions: {
    ...crudActions,

    selectUsuario ({ commit }, value) {
      commit('setUsuario', value)
    },
    selectProceso ({ commit }, value) {
      commit('setProceso', value)
    },
    selectStage ({ commit }, value) {
      commit('setStage', value)
    },
    selectDestacados ({ commit, state }) {
      commit('setDestacados', !state.destacados)
    },
    selectPrioridad ({ commit }, value) {
      commit('setPrioridad', value)
    },
    seleccionarCasos ({ commit }, data) {
      commit('setSeleccion', data)
    },
    arrayParamsSelected ({ commit }, value) { // conservar parametros seleccionados en tarjeta al volver de un caso
      commit('setParamatrosSeleccionados', value)
    },

    async destacar ({ commit, state }, { id, value }) {
      const action = value ? 'fav' : 'unfav'
      try {
        await axios.post(`${state.endpoint}/${action}`, { idcaso: id })
        commit('setProperty', { id, property: 'destacado', value })

        return true
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async check ({ commit, state }, { idcaso, idtarea, value, origin }) {
      const action = value ? 'done' : 'undone'
      try {
        const response = await axios.post(`${state.endpoint}/${action}`, { idcaso, idtarea, origin })
        const data = get(response, 'data.data', {})

        return data
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async duplicar ({ commit, state }, params) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post(`${state.endpoint}/clonar`, params)
        const data = get(response, 'data', {})
        commit('setCreate', data)
        commit('setLoading', -1, { root: true })

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    async getByBifurcacion ({ commit, state }, params) {
      const id = get(params, 'id', 0)
      const idbifurcacion = get(params, 'idbifurcacion', 0)

      if (id === null || id === 0) {
        commit('setOne', {})
        return
      }

      commit('setLoading', 1, { root: true })

      try {
        const response = await axios.get(`${state.endpoint}/getbybifurcacion`, { params: { id, idbifurcacion } })
        const data = get(response, 'data.data', {})
        
        commit('setOne', data)
        commit('setLoading', -1, { root: true })

        return isEmpty(data) ? Promise.reject(new Error()) : data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  },
  modules: {
    procesos,
    notas,
    grupo,
    gruposkill,
    totalsize,
    gruposkillhistory,
    procesossupervision,
    procesossupervisionhistory
  }
}
